import { render, staticRenderFns } from "./ClientFormItem.vue?vue&type=template&id=5bc9153e&scoped=true"
import script from "./ClientFormItem.vue?vue&type=script&lang=js"
export * from "./ClientFormItem.vue?vue&type=script&lang=js"
import style0 from "./ClientFormItem.vue?vue&type=style&index=0&id=5bc9153e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc9153e",
  null
  
)

export default component.exports